import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

export function trimAllControls(control: AbstractControl): void {
  if (control instanceof FormGroup) {
    Object.values(control.controls).forEach(control => trimAllControls(control));

  } else if (control instanceof FormArray) {
    control.controls.forEach(control => trimAllControls(control));

  } else if (control instanceof FormControl) {
    const originalValue = control.value;
    if (originalValue != null) {
      const asString = originalValue.toString();
      const trimmed = asString.trim();
      if (trimmed !== asString) {
        control.setValue(trimmed, { emitEvent: false });
      }
    }
  }
}